import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, overline, updatedAt, children, testId }) => (
  <div className="min-h-screen bg-white" data-testid={testId}>
    <header className="border-b border-slate-200">
      <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
        <Link to="/login" className="flex items-center gap-2.5" data-testid="legal-logo-link">
          <div className="w-9 h-9 rounded-md bg-[#002FA7] flex items-center justify-center">
            <Sparkles className="w-4.5 h-4.5 text-white" strokeWidth={2.2} />
          </div>
          <div>
            <div className="font-display text-base font-bold tracking-tight text-slate-950 leading-none">LOGI</div>
            <div className="font-display text-[10px] font-semibold tracking-[0.18em] text-slate-500 uppercase mt-0.5">SEO Booster</div>
          </div>
        </Link>
        <Link
          to="/login"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-1.5 text-sm text-[#002FA7] font-medium hover:underline"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'application
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-6 py-12">
      <div className="overline mb-2">{overline}</div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-950 mb-2" data-testid="legal-page-title">
        {title}
      </h1>
      <p className="text-sm text-slate-500 mb-10">Dernière mise à jour : {updatedAt}</p>
      <div className="space-y-8">{children}</div>
    </main>

    <footer className="border-t border-slate-200 mt-8">
      <div className="max-w-3xl mx-auto px-6 py-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} LOGI SEO Booster</span>
        <Link to="/confidentialite" className="hover:text-[#002FA7] hover:underline" data-testid="legal-footer-privacy-link">
          Politique de confidentialité
        </Link>
        <Link to="/conditions" className="hover:text-[#002FA7] hover:underline" data-testid="legal-footer-terms-link">
          Conditions d'utilisation
        </Link>
        <a href="mailto:janou.info@gmail.com" className="hover:text-[#002FA7] hover:underline" data-testid="legal-footer-contact-link">
          Contact
        </a>
      </div>
    </footer>
  </div>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-semibold tracking-tight text-slate-950 mb-3">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </section>
);
